import React, { useContext, useCallback } from 'react';
import _ from 'lodash';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';
import metadata from './RiskManagementComponent.metadata.json5';

import styles from '../MedicalPractitioners.module.scss';
import { BreakpointTrackerContext } from '@jutro/legacy/layout';

function RiskManagementComponent(props) {

    const { submissionVM, updateWizardData, pathUpdated } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('RiskManagementComponent');
    const modelVM = _.get(submissionVM, pathUpdated)

    modelVM.value.isValidationReq = true


    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        ifYesPleExp4: {
            visible: !_.isUndefined(modelVM.value.areTheAnyPlaForRenOr3) && modelVM.value.areTheAnyPlaForRenOr3
        },
        howOftAndByWhoAreThe6: {
            visible: !_.isUndefined(modelVM.value.howManFirExtOnPre5) && modelVM.value.howManFirExtOnPre5 > 0
        },
        datOfLasEvaExeCon14: {
            visible: !_.isUndefined(modelVM.value.doYouHavAnEvaPla13) && modelVM.value.doYouHavAnEvaPla13
        },
        doYouConFirDriReg15: {
            visible: !_.isUndefined(modelVM.value.doYouHavAnEvaPla13) && modelVM.value.doYouHavAnEvaPla13
        },
        ifYesPleExp20: {
            visible: !_.isUndefined(modelVM.value.doeTheAppHavARecOf19) && modelVM.value.doeTheAppHavARecOf19
        },
        ifYesPleProTheLatRep22: {
            visible: !_.isUndefined(modelVM.value.theGovBodOfTheAppHas21) && modelVM.value.theGovBodOfTheAppHas21
        },
        numPerYea16: {
            visible: !_.isUndefined(modelVM.value.doYouHavAnEvaPla13) && modelVM.value.doYouHavAnEvaPla13 && !_.isUndefined(modelVM.value.doYouConFirDriReg15) && modelVM.value.doYouConFirDriReg15
        },
    };


    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
        },
        resolveClassNameMap: styles,
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM, `${fullPath}`, value);

            updateWizardData(submissionVM);
        },
        [pathUpdated, submissionVM, updateWizardData]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            // onModelChange={updateWizardData}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

RiskManagementComponent.propTypes = wizardProps;
export default withRouter(RiskManagementComponent);
